module.exports = __webpack_public_path__ + "static/media/insta-top1.746be83e.jpg";